<template>
    <div class="d-flex  text-center"
        :class="[oneLined == 1 ? 'flex-row sm-gap align-items-center mt-1' : 'flex-column mt-3 ']">

        <div class="text-h6 font-weight-bold">{{ readable_default_tarif }}</div>

        <div style="font-size: 12px" v-if="!default_tarif_is_team_price">{{ total_tarif_equipe }}</div>
        <div style="font-size: 10px; position: relative; top: -1px" v-if="show_frais_gestion">
            (+ frais gestion)
        </div>
    </div>
</template>

<script>
import { mapStores } from "pinia";
import { useMainStore } from "@/stores/mainStore";
export default {
    name: 'Tarification_Equipe',
    props: ['tarifs', 'course', 'oneLined'],
    computed: {
        ...mapStores(useMainStore),
        default_tarif() {
            const all_courses = this.mainStore.module.courses.list;
            return this.tarifs.get_default_tarif_on_home(all_courses);
        },
        default_tarif_is_team_price() {
            return this.tarifs.default_tarif_is_team_price();
        },

        readable_default_tarif() {
            if (this.default_tarif == 0) {
                return "Gratuit";
            }
            if (this.default_tarif_is_team_price) {
                return this.default_tarif + "€/équipe";
            }
            return this.default_tarif + "€/pers";
        },
        total_tarif_equipe() {
            const equipe_size = this.course.get_equipe_size();
            const price = this.default_tarif * equipe_size;
            if (price == 0) {
                return "Gratuit";
            }
            return price + "€ / équipe";
        },
        show_frais_gestion() {
            return this.mainStore.module.metadatas?.exclure_taxe != '1' && this.default_tarif != 0;
        },
    },
    methods: {
    },
}
</script>

<style lang="scss" scoped></style>